<!-- <template>
  <div class="modal-wrapper">
    <div class="modal-overlay" @click.self="closeModal">
      <div class="modal-container">
        <div class="modal-header">
          <h3>
            <i class="fas fa-images"></i> Thư viện ảnh
          </h3>
          <button class="btn-close" @click="closeModal">
            <i class="fas fa-times"></i>
          </button>
        </div>
        
        <div class="modal-tabs">
          <button 
            v-for="tab in folderTabs" 
            :key="tab.id"
            :class="{ active: currentTabId === tab.id }"
            @click="currentTabId = tab.id"
          >
            {{ tab.name }}
          </button>
        </div>

        <div class="folder-actions mt-3">
          <input type="text" v-model="newFolderName" placeholder="Tên folder mới" class="input-folder" />
          <button @click="createNewFolder" :disabled="!newFolderName" class="btn-primary">
            <i class="fas fa-plus-circle"></i> Tạo folder
          </button>
          
          <button 
            @click="deleteFolder" 
            :disabled="!currentTabId || !canDeleteFolder"
            class="btn-danger"
          >
            <i class="fas fa-trash-alt"></i> Xóa Folder
          </button>
        </div>

        <div class="modal-body">
          <div v-if="loading" class="state-message loading">
            <i class="fas fa-spinner fa-spin"></i> Đang tải ảnh từ thư mục '{{ currentTab.folderName }}'
          </div>
          <div v-else>
            <div class="tab-content">
              <h4>Ảnh có sẵn</h4>
              <div v-if="images.length === 0" class="state-message empty">
                <i class="fas fa-camera"></i> Chưa có ảnh nào trong thư mục này.
              </div>
              <div v-else class="image-grid">
                <div
                  v-for="image in images"
                  :key="image.url"
                  class="image-item"
                  :class="{ selected: selectedImage === image }"
                  @click="selectedImage = image"
                >
                  <img :src="image.url" :alt="image.title" class="img-fluid" />
                  <div class="image-overlay">
                    <p class="image-title">{{ image.title }}</p>
                    <button class="btn-delete" @click.stop="deleteImage(image)">
                      <i class="fas fa-times-circle"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="image-selection-actions mt-3">
                <button 
                    @click="openImagePreview" 
                    :disabled="!selectedImage" 
                    class="btn-secondary"
                >
                    <i class="fas fa-eye"></i> Xem ảnh
                </button>
                <button 
                    @click="insertSelectedImage" 
                    :disabled="!selectedImage" 
                    class="btn-primary"
                >
                    <i class="fas fa-check-circle"></i> Chèn ảnh
                </button>
            </div>


            <div class="upload-area mt-4">
              <h4>Tải ảnh mới lên thư mục '{{ currentTab.name }}'</h4>
              <label for="file-upload" class="upload-label">
                <i class="fas fa-cloud-upload-alt"></i>
                <p>Kéo và thả ảnh vào đây hoặc click để chọn ảnh</p>
                <input id="file-upload" type="file" @change="handleFileUpload" multiple accept="image/*" class="d-none" />
              </label>
              <div v-if="uploading" class="upload-status text-info">
                <i class="fas fa-spinner fa-spin"></i> Đang tải ảnh lên...
              </div>
              <div v-if="uploadStatus" class="upload-status" :class="uploadStatus.type">
                <i :class="uploadStatus.icon"></i> {{ uploadStatus.message }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showPreviewModal && selectedImage" class="preview-modal-overlay" @click.self="closeImagePreview">
      <div class="preview-modal-content">
        <button class="btn-close-preview" @click="closeImagePreview">
          <i class="fas fa-times"></i>
        </button>
        <img :src="selectedImage.url" :alt="selectedImage.title" class="preview-image" />
        <p class="preview-title">{{ selectedImage.title }}</p>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, watch, computed } from 'vue';
import api from '@/api';

const props = defineProps({
  folderTabs: {
    type: Array,
    required: true
  }
});

const emit = defineEmits(['close', 'file-selected', 'tab-created', 'tab-deleted']);

const currentTabId = ref(props.folderTabs[0]?.id);
const images = ref([]);
const loading = ref(true);
const uploading = ref(false);
const uploadStatus = ref(null);
const newFolderName = ref('');
const selectedImage = ref(null); // Biến mới để lưu ảnh được chọn
const showPreviewModal = ref(false); // Biến mới để điều khiển hiển thị preview modal

const currentTab = computed(() => {
  return props.folderTabs.find(tab => tab.id === currentTabId.value) || {};
});

const canDeleteFolder = computed(() => {
  return images.value.length === 0;
});

const fetchImages = async (folderName) => {
  if (!folderName) return;
  loading.value = true;
  selectedImage.value = null; // Reset ảnh đã chọn khi chuyển folder
  try {
    const res = await api.get(`/api/images/list/${folderName}`);
    images.value = res.data;
  } catch (err) {
    console.error(`Lỗi khi tải danh sách ảnh từ thư mục ${folderName}:`, err);
    images.value = [];
  } finally {
    loading.value = false;
  }
};

const handleFileUpload = async (event) => {
  const files = event.target.files;
  if (!files || files.length === 0) return;
  uploading.value = true;
  uploadStatus.value = null;
  try {
    const formData = new FormData();
    for (const file of files) {
      formData.append('files', file);
    }
    formData.append('folderName', currentTab.value.folderName);
    const res = await api.post('/api/images/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    if (res.data) {
      uploadStatus.value = { message: 'Tải ảnh lên thành công!', type: 'success', icon: 'fas fa-check-circle' };
      fetchImages(currentTab.value.folderName);
    }
  } catch (err) {
    console.error('Lỗi khi tải ảnh lên:', err);
    uploadStatus.value = { message: 'Lỗi khi tải ảnh lên. Vui lòng thử lại.', type: 'danger', icon: 'fas fa-exclamation-triangle' };
  } finally {
    uploading.value = false;
  }
};

const deleteImage = async (image) => {
  if (window.confirm(`Bạn có chắc chắn muốn xóa ảnh "${image.title}"?`)) {
    try {
      const folderName = currentTab.value.folderName;
      const filename = image.url.substring(image.url.lastIndexOf('/') + 1);
      await api.delete(`/api/images/${folderName}/${filename}`);
      images.value = images.value.filter(img => img.url !== image.url);
      if (images.value.length === 0) {
        fetchImages(folderName);
      }
      if (selectedImage.value && selectedImage.value.url === image.url) {
          selectedImage.value = null; // Bỏ chọn nếu ảnh bị xóa là ảnh đang chọn
      }
    } catch (err) {
      console.error('Lỗi khi xóa ảnh:', err);
    }
  }
};

const createNewFolder = async () => {
  if (!newFolderName.value.trim()) {
    alert('Vui lòng nhập tên folder.');
    return;
  }
  try {
    await api.post(`/api/images/create-folder?folderName=${encodeURIComponent(newFolderName.value.trim())}`);
    const newId = newFolderName.value.trim();
    const newTab = {
      id: newId,
      name: newFolderName.value.trim(),
      folderName: newFolderName.value.trim()
    };
    emit('tab-created', newTab);
    alert(`Folder "${newFolderName.value}" đã được tạo thành công.`);
    newFolderName.value = '';
    currentTabId.value = newId;
  } catch (err) {
    console.error('Lỗi khi tạo folder:', err);
    alert('Không thể tạo folder. Vui lòng thử lại.');
  }
};

const deleteFolder = async () => {
  if (!canDeleteFolder.value) {
    alert('Không thể xóa folder vì nó không rỗng.');
    return;
  }
  const folderName = currentTab.value.folderName;
  if (!window.confirm(`Bạn có chắc chắn muốn xóa folder "${folderName}"?`)) {
    return;
  }
  try {
    await api.delete(`/api/images/delete-folder/${folderName}`);
    emit('tab-deleted', currentTab.value.id);
    alert(`Folder "${folderName}" đã được xóa thành công.`);
    const remainingTabs = props.folderTabs.filter(tab => tab.id !== currentTab.value.id);
    currentTabId.value = remainingTabs[0]?.id || null;
    selectedImage.value = null; // Reset ảnh đã chọn khi xóa folder
  } catch (err) {
    console.error('Lỗi khi xóa folder:', err);
    alert(err.response?.data || 'Không thể xóa folder. Vui lòng thử lại.');
  }
};

watch(currentTabId, (newId) => {
  const selectedTab = props.folderTabs.find(tab => tab.id === newId);
  if (selectedTab) {
    fetchImages(selectedTab.folderName);
  }
}, { immediate: true });

watch(() => props.folderTabs, (newTabs) => {
  if (newTabs.length > 0 && (!currentTabId.value || !newTabs.some(tab => tab.id === currentTabId.value))) {
    currentTabId.value = newTabs[0].id;
  } else if (newTabs.length === 0) {
    currentTabId.value = null;
  }
}, { deep: true });

// Hàm mới để mở modal xem trước ảnh
const openImagePreview = () => {
    if (selectedImage.value) {
        showPreviewModal.value = true;
    }
};

// Hàm mới để đóng modal xem trước ảnh
const closeImagePreview = () => {
    showPreviewModal.value = false;
};

// Hàm này sẽ emit ảnh đã chọn để chèn vào nội dung
const insertSelectedImage = () => {
    if (selectedImage.value) {
        emit('file-selected', selectedImage.value);
        closeModal(); // Đóng modal sau khi chèn
    }
};

const closeModal = () => {
  emit('close');
};
</script>
<style scoped>
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css');

.modal-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.modal-overlay {
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal-container {
  background: #fdfdfd;
  border-radius: 12px;
  width: 95%;
  max-width: 900px;
  max-height: 90vh;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #e0e0e0;
}
.modal-header h3 {
  margin: 0;
  font-size: 1.5rem;
  color: #333;
}
.modal-header h3 i {
  margin-right: 10px;
  color: #007bff;
}
.btn-close {
  background: none;
  border: none;
  font-size: 1.2rem;
  color: #6c757d;
  cursor: pointer;
  transition: color 0.2s;
}
.btn-close:hover {
  color: #333;
}
.modal-tabs {
  display: flex;
  border-bottom: 1px solid #e0e0e0;
  padding: 0 20px;
}
.modal-tabs button {
  padding: 12px 18px;
  background: none;
  border: none;
  border-bottom: 3px solid transparent;
  cursor: pointer;
  outline: none;
  font-size: 1rem;
  color: #6c757d;
  font-weight: 500;
  transition: all 0.2s ease-in-out;
}
.modal-tabs button.active {
  color: #007bff;
  border-color: #007bff;
  font-weight: 600;
}
.modal-tabs button:hover:not(.active) {
  background-color: #f1f1f1;
}
.folder-actions {
  display: flex;
  gap: 10px;
  padding: 15px 20px;
  background: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
}
.input-folder {
  flex-grow: 1;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 0.9rem;
  transition: border-color 0.2s;
}
.input-folder:focus {
  outline: none;
  border-color: #007bff;
}
.btn-primary {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 8px 15px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background-color 0.2s;
}
.btn-primary:hover {
  background-color: #0056b3;
}
.btn-primary:disabled {
  background-color: #a0a0a0;
  cursor: not-allowed;
}
/* New button style for secondary actions like "View Image" */
.btn-secondary {
    background-color: #6c757d;
    color: white;
    border: none;
    padding: 8px 15px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 0.9rem;
    transition: background-color 0.2s;
}
.btn-secondary:hover {
    background-color: #5a6268;
}
.btn-secondary:disabled {
    background-color: #a0a0a0;
    cursor: not-allowed;
}
.btn-danger {
  background-color: #dc3545;
  color: white;
  border: none;
  padding: 8px 15px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background-color 0.2s;
}
.btn-danger:hover {
  background-color: #b02a37;
}
.btn-danger:disabled {
  background-color: #a0a0a0;
  cursor: not-allowed;
}
.btn-primary i, .btn-danger i, .btn-secondary i {
  margin-right: 5px;
}
.modal-body {
  padding: 20px;
  overflow-y: auto;
  flex-grow: 1;
}
.state-message {
  text-align: center;
  padding: 40px;
  color: #6c757d;
  font-style: italic;
}
.state-message i {
  display: block;
  font-size: 3rem;
  margin-bottom: 10px;
  color: #ced4da;
}
.image-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 20px;
  margin-top: 20px;
}
.image-item {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  transition: transform 0.2s ease-in-out, border 0.2s;
}
.image-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}
/* Highlight selected image */
.image-item.selected {
    border: 3px solid #007bff;
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.5);
}
.image-item img {
  width: 100%;
  height: 150px;
  object-fit: cover;
  display: block;
}
.image-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 10px;
  transform: translateY(100%);
  transition: transform 0.3s ease-in-out;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.image-item:hover .image-overlay {
  transform: translateY(0);
}
.image-title {
  margin: 0;
  font-size: 0.9rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.btn-delete {
  background: none;
  border: none;
  color: white;
  font-size: 1.2rem;
  cursor: pointer;
  transition: color 0.2s;
}
.btn-delete:hover {
  color: #dc3545;
}

/* New: Action buttons for selected image */
.image-selection-actions {
    display: flex;
    justify-content: center;
    gap: 15px;
    margin-top: 25px;
    padding-top: 15px;
    border-top: 1px solid #eee;
}

.upload-area {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px;
  border: 2px dashed #a0a0a0;
  border-radius: 12px;
  text-align: center;
  transition: border-color 0.2s;
}
.upload-area:hover {
  border-color: #007bff;
}
.upload-label {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.upload-label i {
  font-size: 4rem;
  color: #007bff;
}
.upload-label p {
  margin: 10px 0 0;
  color: #555;
  font-size: 1.1rem;
}
.d-none {
  display: none;
}
.upload-status {
  margin-top: 15px;
  padding: 10px 20px;
  border-radius: 6px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 10px;
}
.upload-status.success {
  background-color: #d4edda;
  color: #155724;
}
.upload-status.danger {
  background-color: #f8d7da;
  color: #721c24;
}
.upload-status.text-info {
  color: #007bff;
}

/* --- Image Preview Modal Styles --- */
.preview-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.85); /* Darker overlay */
  z-index: 2001; /* Higher than main modal */
  display: flex;
  justify-content: center;
  align-items: center;
}
.preview-modal-content {
  background: #fff;
  border-radius: 12px;
  padding: 25px;
  max-width: 90%;
  max-height: 90%;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.btn-close-preview {
  position: absolute;
  top: 15px;
  right: 15px;
  background: rgba(0, 0, 0, 0.5);
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  color: white;
  cursor: pointer;
  z-index: 2002;
  transition: background-color 0.2s;
}
.btn-close-preview:hover {
  background-color: rgba(0, 0, 0, 0.7);
}
.preview-image {
  max-width: 100%;
  max-height: 70vh; /* Adjust as needed */
  object-fit: contain;
  border-radius: 8px;
  margin-bottom: 15px;
}
.preview-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
  text-align: center;
  word-break: break-word;
}
</style> -->


<template>
  <div class="modal-wrapper">
    <div class="modal-overlay" @click.self="closeModal">
      <div class="modal-container">
        <div class="modal-header">
          <h3>
            <i class="fa fa-images"></i> Thư viện ảnh
          </h3>
          <button class="btn-close" @click="closeModal">
            <i class="fa fa-times"></i>
          </button>
        </div>
        
        <div class="folder-selection-container">
          <label for="folder-select" class="folder-label">Chọn thư mục:</label>
          <select id="folder-select" v-model="currentTabId" class="folder-select">
            <option v-for="tab in folderTabs" :key="tab.id" :value="tab.id">
              {{ tab.name }}
            </option>
          </select>
        </div>

        <div class="folder-actions-combined mt-3">
          <div class="folder-actions">
            <input type="text" v-model="newFolderName" placeholder="Tên folder mới" class="input-folder" />
            <button @click="createNewFolder" :disabled="!newFolderName" class="btn-primary">
              <i class="fa fa-plus-circle"></i> Tạo folder
            </button>
            <button 
              @click="deleteFolder" 
              :disabled="!currentTabId || !canDeleteFolder"
              class="btn-danger"
            >
              <i class="fa fa-trash"></i> Xóa Folder
            </button>
          </div>
          
          <div class="upload-actions">
            <label for="file-upload" class="btn-primary upload-label">
              <i class="fa fa-upload"></i> Tải ảnh lên
            </label>
            <input id="file-upload" type="file" @change="handleFileUpload" multiple accept="image/*" class="d-none" />
          </div>
        </div>

        <div class="modal-body">
          <div v-if="loading" class="state-message loading">
            <i class="fa fa-spinner fa-spin"></i> Đang tải ảnh từ thư mục '{{ currentTab.folderName }}'
          </div>
          <div v-else>
            <div class="tab-content">
              <h4>Tìm kiếm ảnh</h4>
              <div class="search-bar">
                <input 
                  type="text" 
                  v-model="searchQuery" 
                  placeholder="Tìm ảnh theo tên..." 
                  class="input-search" 
                />
                <i class="fa fa-search search-icon"></i>
              </div>

              <div v-if="filteredImages.length === 0" class="state-message empty">
                <i class="fa fa-camera"></i> Không tìm thấy ảnh nào.
              </div>
              <div v-else class="image-grid">
                <div
                  v-for="image in paginatedImages"
                  :key="image.url"
                  class="image-item"
                  :class="{ selected: selectedImage && selectedImage.url === image.url }"
                  @click="selectedImage = image"
                >
                  <img :src="image.url" :alt="image.title" class="img-fluid" />
                  <div class="image-overlay">
                    <p class="image-title">{{ image.title }}</p>
                    <button class="btn-delete" @click.stop="deleteImage(image)">
                      <i class="fa fa-times-circle"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            
            <div v-if="filteredTotalPages > 1" class="pagination-controls">
                <button @click="currentPage--" :disabled="currentPage === 1" class="btn-page">
                    <i class="fa fa-chevron-left"></i>
                </button>
                <span class="page-info">Trang {{ currentPage }} / {{ filteredTotalPages }}</span>
                <button @click="currentPage++" :disabled="currentPage === filteredTotalPages" class="btn-page">
                    <i class="fa fa-chevron-right"></i>
                </button>
            </div>

            <div class="image-selection-actions mt-3">
                <button 
                    @click="openImagePreview" 
                    :disabled="!selectedImage" 
                    class="btn-secondary"
                >
                    <i class="fa fa-eye"></i> Xem ảnh
                </button>
                <button 
                    @click="insertSelectedImage" 
                    :disabled="!selectedImage" 
                    class="btn-primary"
                >
                    <i class="fa fa-check-circle"></i> Chèn ảnh
                </button>
            </div>
            
            <div v-if="uploading" class="upload-status text-info">
              <i class="fa fa-spinner fa-spin"></i> Đang tải ảnh lên...
            </div>
            <div v-if="uploadStatus" class="upload-status" :class="uploadStatus.type">
              <i :class="uploadStatus.icon"></i> {{ uploadStatus.message }}
            </div>

          </div>
        </div>
      </div>
    </div>

    <div v-if="showPreviewModal && selectedImage" class="preview-modal-overlay" @click.self="closeImagePreview">
      <div class="preview-modal-content">
        <button class="btn-close-preview" @click="closeImagePreview">
          <i class="fa fa-times"></i>
        </button>
        <img :src="selectedImage.url" :alt="selectedImage.title" class="preview-image" />
        <p class="preview-title">{{ selectedImage.title }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, computed } from 'vue';
import api from '@/api';

const props = defineProps({
  folderTabs: {
    type: Array,
    required: true
  }
});

const emit = defineEmits(['close', 'file-selected', 'tab-created', 'tab-deleted']);

const currentTabId = ref(props.folderTabs[0]?.id);
const images = ref([]);
const loading = ref(true);
const uploading = ref(false);
const uploadStatus = ref(null);
const newFolderName = ref('');
const selectedImage = ref(null);
const showPreviewModal = ref(false);

const searchQuery = ref('');
const currentPage = ref(1);
const imagesPerPage = 12;

const filteredImages = computed(() => {
  if (!searchQuery.value) {
    return images.value;
  }
  const query = searchQuery.value.toLowerCase();
  return images.value.filter(image => 
    image.title.toLowerCase().includes(query) || image.url.toLowerCase().includes(query)
  );
});

const filteredTotalPages = computed(() => {
    return Math.ceil(filteredImages.value.length / imagesPerPage);
});

const paginatedImages = computed(() => {
    const startIndex = (currentPage.value - 1) * imagesPerPage;
    const endIndex = startIndex + imagesPerPage;
    return filteredImages.value.slice(startIndex, endIndex);
});

const currentTab = computed(() => {
  return props.folderTabs.find(tab => tab.id === currentTabId.value) || {};
});

const canDeleteFolder = computed(() => {
  return images.value.length === 0;
});

const fetchImages = async (folderName) => {
  if (!folderName) return;
  loading.value = true;
  selectedImage.value = null;
  searchQuery.value = '';
  currentPage.value = 1;
  try {
    const res = await api.get(`/api/images/list/${folderName}`);
    images.value = res.data.sort((a, b) => new Date(b.uploadedAt) - new Date(a.uploadedAt));
  } catch (err) {
    console.error(`Lỗi khi tải danh sách ảnh từ thư mục ${folderName}:`, err);
    images.value = [];
  } finally {
    loading.value = false;
  }
};

const handleFileUpload = async (event) => {
  const files = event.target.files;
  if (!files || files.length === 0) return;
  uploading.value = true;
  uploadStatus.value = null;
  try {
    const formData = new FormData();
    for (const file of files) {
      formData.append('files', file);
    }
    formData.append('folderName', currentTab.value.folderName);
    const res = await api.post('/api/images/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    if (res.data) {
      uploadStatus.value = { message: 'Tải ảnh lên thành công!', type: 'success', icon: 'fa fa-check-circle' };
      fetchImages(currentTab.value.folderName);
    }
  } catch (err) {
    console.error('Lỗi khi tải ảnh lên:', err);
    uploadStatus.value = { message: 'Lỗi khi tải ảnh lên. Vui lòng thử lại.', type: 'danger', icon: 'fa fa-exclamation-triangle' };
  } finally {
    uploading.value = false;
  }
};

const deleteImage = async (image) => {
  if (window.confirm(`Bạn có chắc chắn muốn xóa ảnh "${image.title}"?`)) {
    try {
      const folderName = currentTab.value.folderName;
      const filename = image.url.substring(image.url.lastIndexOf('/') + 1);
      await api.delete(`/api/images/${folderName}/${filename}`);
      images.value = images.value.filter(img => img.url !== image.url);
      if (images.value.length === 0) {
        fetchImages(folderName);
      }
      if (selectedImage.value && selectedImage.value.url === image.url) {
          selectedImage.value = null;
      }
    } catch (err) {
      console.error('Lỗi khi xóa ảnh:', err);
    }
  }
};

const createNewFolder = async () => {
  if (!newFolderName.value.trim()) {
    alert('Vui lòng nhập tên folder.');
    return;
  }
  try {
    await api.post(`/api/images/create-folder?folderName=${encodeURIComponent(newFolderName.value.trim())}`);
    const newId = newFolderName.value.trim();
    const newTab = {
      id: newId,
      name: newFolderName.value.trim(),
      folderName: newFolderName.value.trim()
    };
    emit('tab-created', newTab);
    alert(`Folder "${newFolderName.value}" đã được tạo thành công.`);
    newFolderName.value = '';
    currentTabId.value = newId;
  } catch (err) {
    console.error('Lỗi khi tạo folder:', err);
    alert('Không thể tạo folder. Vui lòng thử lại.');
  }
};

const deleteFolder = async () => {
  if (!canDeleteFolder.value) {
    alert('Không thể xóa folder vì nó không rỗng.');
    return;
  }
  const folderName = currentTab.value.folderName;
  if (!window.confirm(`Bạn có chắc chắn muốn xóa folder "${folderName}"?`)) {
    return;
  }
  try {
    await api.delete(`/api/images/delete-folder/${folderName}`);
    emit('tab-deleted', currentTab.value.id);
    alert(`Folder "${folderName}" đã được xóa thành công.`);
    const remainingTabs = props.folderTabs.filter(tab => tab.id !== currentTab.value.id);
    currentTabId.value = remainingTabs[0]?.id || null;
    selectedImage.value = null;
    currentPage.value = 1;
    searchQuery.value = '';
  } catch (err) {
    console.error('Lỗi khi xóa folder:', err);
    alert(err.response?.data || 'Không thể xóa folder. Vui lòng thử lại.');
  }
};

watch(currentTabId, (newId) => {
  const selectedTab = props.folderTabs.find(tab => tab.id === newId);
  if (selectedTab) {
    fetchImages(selectedTab.folderName);
  }
}, { immediate: true });

watch(searchQuery, () => {
  currentPage.value = 1;
});

watch(() => props.folderTabs, (newTabs) => {
  if (newTabs.length > 0 && (!currentTabId.value || !newTabs.some(tab => tab.id === currentTabId.value))) {
    currentTabId.value = newTabs[0].id;
  } else if (newTabs.length === 0) {
    currentTabId.value = null;
  }
}, { deep: true });

const openImagePreview = () => {
    if (selectedImage.value) {
        showPreviewModal.value = true;
    }
};

const closeImagePreview = () => {
    showPreviewModal.value = false;
};

const insertSelectedImage = () => {
    if (selectedImage.value) {
        emit('file-selected', selectedImage.value);
        closeModal();
    }
};

const closeModal = () => {
  emit('close');
};
</script>

<style scoped>
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css');

.modal-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  padding: 10px;
  box-sizing: border-box;
}
.modal-overlay {
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal-container {
  background: #fdfdfd;
  border-radius: 12px;
  width: 95%;
  max-width: 900px;
  max-height: 90vh;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #e0e0e0;
}
.modal-header h3 {
  margin: 0;
  font-size: 1.5rem;
  color: #333;
}
.modal-header h3 i {
  margin-right: 10px;
  color: #007bff;
}
.btn-close {
  background: none;
  border: none;
  font-size: 1.2rem;
  color: #6c757d;
  cursor: pointer;
  transition: color 0.2s;
}
.btn-close:hover {
  color: #333;
}

.folder-selection-container {
    display: flex;
    align-items: center;
    gap: 15px;
    padding: 15px 20px;
    background: #f5f5f5;
    border-bottom: 1px solid #e0e0e0;
}
.folder-label {
    font-size: 1rem;
    color: #555;
    font-weight: 500;
}
.folder-select {
    flex-grow: 1;
    padding: 8px 12px;
    border: 1px solid #ccc;
    border-radius: 6px;
    background-color: #fff;
    cursor: pointer;
    font-size: 0.9rem;
    transition: border-color 0.2s;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='none' stroke='%23333' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 10px center;
    background-size: 12px;
}
.folder-select:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);
}

.folder-actions-combined {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
  padding: 15px 20px;
  background: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
}
.folder-actions {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-grow: 1;
  flex-wrap: wrap;
}
.input-folder {
  flex-grow: 1;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 0.9rem;
  transition: border-color 0.2s;
}
.input-folder:focus {
  outline: none;
  border-color: #007bff;
}
.upload-actions {
  display: flex;
  align-items: center;
}
.btn-primary {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 8px 15px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background-color 0.2s;
}
.btn-primary:hover {
  background-color: #0056b3;
}
.btn-primary:disabled {
  background-color: #a0a0a0;
  cursor: not-allowed;
}
.btn-secondary {
    background-color: #6c757d;
    color: white;
    border: none;
    padding: 8px 15px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 0.9rem;
    transition: background-color 0.2s;
}
.btn-secondary:hover {
    background-color: #5a6268;
}
.btn-secondary:disabled {
    background-color: #a0a0a0;
    cursor: not-allowed;
}
.btn-danger {
  background-color: #dc3545;
  color: white;
  border: none;
  padding: 8px 15px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background-color 0.2s;
}
.btn-danger:hover {
  background-color: #b02a37;
}
.btn-danger:disabled {
  background-color: #a0a0a0;
  cursor: not-allowed;
}
.btn-primary i, .btn-danger i, .btn-secondary i {
  margin-right: 5px;
}
.upload-label {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 8px 15px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
}
.upload-label:hover {
  background-color: #0056b3;
}

.modal-body {
  padding: 20px;
  overflow-y: auto;
  flex-grow: 1;
}
.state-message {
  text-align: center;
  padding: 40px;
  color: #6c757d;
  font-style: italic;
}
.state-message i {
  display: block;
  font-size: 3rem;
  margin-bottom: 10px;
  color: #ced4da;
}
.image-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 20px;
  margin-top: 20px;
}
.image-item {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  transition: transform 0.2s ease-in-out, border 0.2s;
}
.image-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}
.image-item.selected {
    border: 3px solid #007bff;
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.5);
}
.image-item img {
  width: 100%;
  height: 150px;
  object-fit: cover;
  display: block;
}
.image-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 10px;
  transform: translateY(100%);
  transition: transform 0.3s ease-in-out;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.image-item:hover .image-overlay {
  transform: translateY(0);
}
.image-title {
  margin: 0;
  font-size: 0.9rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.btn-delete {
  background: none;
  border: none;
  color: white;
  font-size: 1.2rem;
  cursor: pointer;
  transition: color 0.2s;
}
.btn-delete:hover {
  color: #dc3545;
}

.pagination-controls {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    margin-top: 20px;
    padding: 10px;
    border-top: 1px solid #e0e0e0;
}
.btn-page {
    background-color: #f1f1f1;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 8px 12px;
    cursor: pointer;
    font-size: 0.9rem;
    transition: all 0.2s ease;
}
.btn-page:hover:not(:disabled) {
    background-color: #e0e0e0;
    border-color: #a0a0a0;
}
.btn-page:disabled {
    cursor: not-allowed;
    opacity: 0.5;
}
.page-info {
    font-size: 0.9rem;
    color: #6c757d;
}
.image-selection-actions {
    display: flex;
    justify-content: center;
    gap: 15px;
    margin-top: 25px;
    padding-top: 15px;
    border-top: 1px solid #eee;
}
.upload-status {
  margin-top: 15px;
  padding: 10px 20px;
  border-radius: 6px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 10px;
}
.upload-status.success {
  background-color: #d4edda;
  color: #155724;
}
.upload-status.danger {
  background-color: #f8d7da;
  color: #721c24;
}
.upload-status.text-info {
  color: #007bff;
}

.d-none {
  display: none;
}
.preview-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.85);
  z-index: 2001;
  display: flex;
  justify-content: center;
  align-items: center;
}
.preview-modal-content {
  background: #fff;
  border-radius: 12px;
  padding: 25px;
  max-width: 90%;
  max-height: 90%;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.btn-close-preview {
  position: absolute;
  top: 15px;
  right: 15px;
  background: rgba(0, 0, 0, 0.5);
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  color: white;
  cursor: pointer;
  z-index: 2002;
  transition: background-color 0.2s;
}
.btn-close-preview:hover {
  background-color: rgba(0, 0, 0, 0.7);
}
.preview-image {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
  border-radius: 8px;
  margin-bottom: 15px;
}
.preview-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
  text-align: center;
  word-break: break-word;
}

/* New search bar styles */
.search-bar {
  position: relative;
  margin-bottom: 20px;
  margin-top: 10px;
  display: flex;
  align-items: center;
}
.input-search {
  flex-grow: 1;
  padding: 10px 15px 10px 40px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.input-search:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);
}
.search-icon {
  position: absolute;
  left: 15px;
  color: #6c757d;
  font-size: 1rem;
}

/* Responsive Styles */
@media (max-width: 768px) {
  .modal-container {
    width: 100%;
    max-width: 100%;
    max-height: 100vh;
    border-radius: 0;
  }
  .modal-header {
    padding: 15px;
  }
  .modal-header h3 {
    font-size: 1.25rem;
  }
  .btn-close {
    font-size: 1rem;
  }
  .folder-selection-container {
      flex-direction: column;
      align-items: stretch;
  }
  .folder-label {
      text-align: center;
  }
  .folder-actions-combined {
    flex-direction: column;
    align-items: stretch;
    padding: 10px;
  }
  .folder-actions {
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
  }
  .input-folder {
    flex-grow: 1;
  }
  .upload-actions {
    margin-top: 10px;
    width: 100%;
  }
  .upload-label {
    width: 100%;
    justify-content: center;
  }
  .btn-primary, .btn-danger {
    padding: 8px 10px;
    font-size: 0.8rem;
    flex-shrink: 0;
  }
  .modal-body {
    padding: 15px;
  }
  .image-grid {
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 10px;
  }
  .image-item img {
    height: 100px;
  }
  .image-overlay {
    padding: 5px;
  }
  .image-title {
    font-size: 0.8rem;
  }
  .btn-delete {
    font-size: 1rem;
  }
  .image-selection-actions {
    flex-direction: column;
    gap: 10px;
  }
  .btn-secondary, .btn-primary {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .folder-actions {
    flex-direction: column;
    align-items: stretch;
  }
  .folder-actions button {
    width: 100%;
    margin-top: 5px;
  }
  .input-folder {
    width: 100%;
  }
}
</style>